import {Component, Injector} from '@angular/core';
import {ClientConfigurationScheme, ComponentConfiguration, ComponentInit, InitialConfig} from '@twpub/core/utils';
import {ResultView} from '@twpub/core/models';
import {ComponentCategory} from '@twpub/core/enums';
import {BaseResultViewComponent} from '@twpub/shared/components/base/base-result-view/base-result-view.component';

import {FieldRenderComponent} from '../../../../shared/components/renders/field-render/field-render.component';
import {RenderRelationsComponent} from '../render-relations/render-relations.component';

@Component({
  selector: 'pub-short-result-view',
  templateUrl: './short-result-view.component.html',
  styleUrls: ['./short-result-view.component.scss'],
  standalone: true,
  imports: [FieldRenderComponent, RenderRelationsComponent]
})
export class ShortResultViewComponent extends BaseResultViewComponent {
  constructor(injector: Injector) {
    super(injector);
  }

  static Init = class extends ComponentInit {
    readonly scheme = ClientConfigurationScheme.DEFAULT;

    constructor() {
      super(ShortResultViewComponent, 'ShortResultViewComponent', 'Short Result View', [ComponentCategory.ResultView]);
    }

    createConfig(initialConfig: InitialConfig = undefined) {
      return new ComponentConfiguration<ResultView>(ShortResultViewComponent, this.name, initialConfig);
    }
  }

  override doUpdate(): void {
    super.doUpdate()
    this.classificationFields = [
      {oid: 'cid', jsonField: 'cid', label: 'Concept ID', value: this.concept?.cid},
      {oid: 'concept-id', jsonField: 'concept-id', label: 'System ID', value: this.concept?.id.toString()}
    ];
  }
}
